let env = 'prod'

let baseApi = 'https://www.ku52.cn'

let artifactId = 'kushu'

// let mqttUrl = 'wss://push.ku52.cn:9884'
let domainStr = ".ku52.cn"

// if (window.location.protocol === "https:") {
//   // https
// } else {
//   // http
//   mqttUrl = 'ws://push.ku52.cn:9885/'
// }

let baseV4Pre = baseApi + "/v2/v4/index.html"

export {baseApi, artifactId, env, domainStr, baseV4Pre}